/**
 * 启动闪屏页面
 * 展示应用介绍和品牌信息
 */

import React, { useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  StatusBar,
  TouchableOpacity,
} from 'react-native';
import { VERSION_INFO, getVersionString } from '../config/version';

const { width, height } = Dimensions.get('window');

interface SplashScreenProps {
  onFinish: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onFinish }) => {
  useEffect(() => {
    // 3秒后自动跳转
    const timer = setTimeout(() => {
      onFinish();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <View style={styles.container}>
      {/* 简单版本 */}
      <View style={styles.contentContainer}>
        <Text style={styles.appName}>ChatFluent</Text>
        <Text style={styles.subtitle}>AI 智能语言学习伙伴</Text>
        
        {/* 版本信息 */}
        <View style={styles.versionContainer}>
          <Text style={styles.versionText}>{getVersionString()}</Text>
          <Text style={styles.buildText}>Build {VERSION_INFO.buildNumber}</Text>
        </View>

        <TouchableOpacity style={styles.startButton} onPress={onFinish}>
          <Text style={styles.startButtonText}>开始体验</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#2c3e50',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  appName: {
    fontSize: 36,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 10,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 18,
    color: '#bdc3c7',
    marginBottom: 30,
    textAlign: 'center',
  },
  versionContainer: {
    alignItems: 'center',
    marginBottom: 30,
  },
  versionText: {
    fontSize: 16,
    color: '#95a5a6',
    textAlign: 'center',
  },
  buildText: {
    fontSize: 14,
    color: '#7f8c8d',
    textAlign: 'center',
    marginTop: 2,
  },
  startButton: {
    backgroundColor: '#e74c3c',
    paddingVertical: 16,
    paddingHorizontal: 50,
    borderRadius: 30,
  },
  startButtonText: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default SplashScreen;
